import axios from './axios-instance';

// 获取通知消息
export function queryNotification(params) {
  return axios.get('/order/auth/notice/center', { params });
}

// 设为已读
export function updateNotificationStatus(params) {
  return axios.get('/order/auth/notice/center/read', {
    params,
  });
}
